import React,{useMemo,useState,useEffect} from 'react';
import MaterialReactTable from 'material-react-table';
import {Box,Button,Table ,Checkbox,FormControlLabel,Tooltip ,TableCell ,Paper,useMediaQuery,TableRow,Grid,Dialog, DialogActions, DialogTitle, 
    DialogContentText, DialogContent,Typography,Card,IconButton,TextField,CardContent,FormControl,InputLabel,Select,OutlinedInput,MenuItem} from '@mui/material';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { ExportToCsv } from 'export-to-csv'; //or use your library of choice here
import { fetchData, postData } from '../../../../redux/apiSlice';
import {  useDispatch } from 'react-redux';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import swal from "sweetalert";
import AuthUser from '../../../../Components/Auth/AuthUser';
import {  useNavigate} from 'react-router-dom';
import Moment from 'moment';
import { CardOverflow } from '@mui/joy';
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function MediaServiceReqestedAffiliateList(props) {
    const dispatch = useDispatch();
    const {http,user} = AuthUser();
    const [rowSelection, setRowSelection] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const rowsSeleted = Object.keys(rowSelection);
    const [data, setData] = useState([]);
    const [columnVisibility, setColumnVisibility] = React.useState({});
    const navigate = useNavigate();
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('md');
    const [open, setOpen] = React.useState(false);
    const [openReassign, setOpenReassign] = React.useState(false);
    const [openAssign, setOpenAssign] = React.useState(false);
    const [openAssignTo, setOpenAssignTo] = useState(false);
    const [singleOpenAssignTo, setSingleOpenAssignTo] = useState(false);
    const [assignItem, setAssignItem] = useState([]);
    const [itemType, setItemType] = useState("");
    const [companyDetails, setCompanyDetails] = useState({});
    const isMobile = useMediaQuery('(max-width:600px)');
    const [selectAllValue, setSelectAllValue] = useState('');
    const [assignmentsById, setAssignmentsById] = useState({});
    const [assignToValue, setAssignToValue] = useState("");
    const [singleAssignError, setSingleAssignError] = useState(false);
    const [multiAssignBtnDisable, setMultiAssignBtnDisable] = useState(false);
    const [assignBtnDisable, setAssignBtnDisable] = useState(false);
    const [adminList, setAdminList] = React.useState([]);
    const [assigedUser, setAssigedUser] = React.useState();
    const [configId, setConfigId] = React.useState();
    const loginUser = JSON.parse(localStorage.getItem('user'));
    const [assignTo, setAssignTo] = useState("Me");
    const [note, setNote] = useState('');
    const handleSelectAllChange = (checked) => {
        setSelectAll(checked);
        if (!checked) setSelectAll(false);
      };
    const tablePreferencesArray = {
    }

    const handleClickOpen = (companyDetailsData) => {
        let checkAssign = false;
        setCompanyDetails(companyDetailsData);
        if(companyDetailsData.original.video_config && companyDetailsData.original.video_config.length != 0) {
            if(companyDetailsData.original.video_config[0].assigned_to != null) {
                setSelectAllValue(companyDetailsData.original.video_config[0].assigned_to);
                companyDetailsData?.original?.video_config?.forEach(video => {
                    setAssignmentsById(prev => ({
                        ...prev,
                        [video.id]: video.assigned_to
                    }));
                });
                checkAssign = true;
            }
            if(checkAssign == false) {
                if(companyDetailsData.original.logo_config != null && companyDetailsData.original.logo_config.assigned_to != null) {
                    setSelectAllValue(companyDetailsData.original.logo_config.assigned_to);
                    checkAssign = true;
                    setAssignmentsById(prev => ({
                        ...prev,
                        [companyDetailsData.original.logo_config.id]: companyDetailsData.original.logo_config.assigned_to
                    }));
                }
            }
        }
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpenAssignTo = (item,type) => {
        setAssignItem(item);
        setItemType(type);
        setAssignToValue(item.assigned_to != null ? item.assigned_to : '');
        setSingleOpenAssignTo(true);
        setSingleAssignError(false);
    };

    const handleCloseAssignTo = () => {
        setAssignBtnDisable(false);
        setAssignItem([]);
        setItemType("");
        setAssignToValue("");
        setSingleAssignError(false);
        setSingleOpenAssignTo(false);
    };

  const fetchSalesAdminList = async () => {
    const apiUrl = '/fetchSalesAdmins'; // Replace with your API endpoint
    const res = await dispatch(fetchData(apiUrl)).unwrap();
    if (res) {
      setAdminList(res);
    }
  }

    useEffect(() => {
        {loginUser.roles_id ==15 ? getEligibleAffiliates(assignTo) :getEligibleAffiliates()}
       fetchSalesAdminList();
    }, []);

    useEffect(() => {
        if (Object.values(columnVisibility).length > 0) {
            setColumnVisibility(columnVisibility);
        }
        //do something when the row selection changes...
    }, [rowSelection]);
    
    useEffect(() => {
        tablePreferences();
    }, [rowSelection]);
    ////////////////////////
    
    useEffect(() => {
        if (Object.values(columnVisibility).length > 0) {
            http.post('/saveTablePreferences', {
                columnArray: columnVisibility,
                userId: user.id,
                tableId: 'requestedMediaServicesAffiliates'
            }).then((result) => {
            })
        }
    }, [columnVisibility])

    const tablePreferences = () => {
        http.get('/fetchTablePreferences/requestedMediaServicesAffiliates')
            .then((res) => {
                if (Object.values(res.data).length == 0) {
                    setColumnVisibility(tablePreferencesArray);
                } else {
                    setColumnVisibility((JSON.parse(res.data.preferences)));
                }
            });
    }

   const getActivityLog =(companyId) => {
    var check = checkUserRole();
    if(check === true) {
        navigate('/media-services-log/' + companyId)
    }
   }

    const getEligibleAffiliates = async(assignedToValue=null) => {
        props.handleFreezStart();

        const apiUrl = '/adminMediaServices';
        const args = {
            assignAgent:assignedToValue,
            requestType: "requested",
        }
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res) {
            if (res.success == true) {
                props.handleFreezStop();
                setData(res.data);
            } else {
                props.handleFreezStop();
            }
        } else {
            swal({
                title: "Failed",
                text: "Network Error",
                icon: "error",
                button: "Ok",
            });
        }
    }
    
    const checkUserRole = () => {
        
        if(loginUser.roles_id != 1 && loginUser.roles_id != 2 && loginUser.roles_id != 15) {
            swal({
                title: "Failed",
                text: "This action is unauthorized.",
                icon: "error",
                button: "Ok",
            })
            navigate('/login');
            return false;
        }else{
            return true;
        }
    };

    const reAssignUser = (type,retentionId, userId) => {
        if(loginUser.roles_id < 3 ||  loginUser.roles_id == 15) {
        setAssigedUser(userId);
        setItemType(type);
        setConfigId(retentionId);
        setNote('');
        handleClick();
        }else {
        navigate('/login');
        return false;
        }
    };

    const handleClick = () => {
        setOpenReassign(true);
    };

    const handle = () => {
        setOpenReassign(false);
    };

    const ChangeAssignedUser = async () => {
    if (note.trim() === '') {
        alert("Please Enter Note")
        return; 
    }
    const apiUrl = '/reassign-agent';
    const args = {
        type : itemType,
        configId: configId,
        assigedUser: assigedUser,
        note: note
    }
    const res = await dispatch(postData({ apiUrl, args })).unwrap();
    if (res) {
        if (res.success === true) {
        setOpenReassign(false);
        swal({
            title: "Success",
            text: res.message,
            icon: "success",
            button: "Ok",
        })
        {loginUser.roles_id ==15 ? getEligibleAffiliates(assignTo) :getEligibleAffiliates()}
        } else {
        console.log('else');
        }
    }
    }

   const columns = useMemo(
        //column definitions...
        () => [
            {
                accessorFn: (data) => `${data.company.company_name.trim()}`,
                id: 'company_name',
                header: 'Company Name',
                size: 50,
                enablePinning: true,
            },
            {
                accessorFn: (data) => `${ data.created_at ? Moment(data.created_at).tz('America/Los_Angeles').format('MM-DD-YYYY') : '' } `,
                enableClickToCopy: true,
                id: 'requested_date',
                header: 'Requested Date',
                size: 150,
                Cell: ({ renderedCellValue, row }) => (
                    row.original.created_at?  Moment(row.original.created_at).tz('America/Los_Angeles').format('MM-DD-YYYY'): ''
                ),
   
            },
            {
                accessorFn: (data) => `${data}`,
                id: 'AssignTo',
                header: 'Assign To',
                size: 50,
                Cell: ({ renderedCellValue, row }) => (
                    <>
                   { row.original.video_config ? 
                    <>
                    {row.original.video_config.map((video, index) => (
                      <div key={index}>
                        {video.media_service && video.assigned_to != null && video.sales_admin?  video.sales_admin.name : <AddCircleOutlineIcon fontSize="medium" onClick={() => handleClickOpenAssignTo(video,"video")} sx={{ cursor: 'pointer' }} />}
                            {loginUser.roles_id < 3 && video.media_service && video.assigned_to != null && video.sales_admin ?
                                <Button onClick={() => { reAssignUser("video",video.id, video.assigned_to) }} ><Tooltip title="ReAssign" arrow><img src={require('../../../../assets/images/reactivate.png')} /></Tooltip></Button>
                                : ''}
                                {loginUser.roles_id == 15 && video.media_service && video.assigned_to != null && video.assigned_to == loginUser.id
                                 ? <Button onClick={() => { reAssignUser("video",video.id,null) }}><Tooltip title="UnAssign" arrow><img src={require('../../../../assets/images/reactivate.png')} /></Tooltip></Button>:''}
                      </div>
                    ))}
                  </>
                    :''}
                    
                       { row.original.logo_config ? 
                        <>
                        {
                            row.original.logo_config && row.original.logo_config.assigned_to != null &&  row.original.logo_config.sales_admin ? row.original.logo_config.sales_admin.name : <AddCircleOutlineIcon fontSize="medium" onClick={() => handleClickOpenAssignTo(row.original.logo_config,"logo")}/>
                        }
                        {loginUser.roles_id < 3 && row.original.logo_config && row.original.logo_config.assigned_to != null &&  row.original.logo_config.sales_admin ?
                            <Button onClick={() => { reAssignUser("logo",row.original.logo_config.id, row.original.logo_config.assigned_to) }} ><Tooltip title="ReAssign" arrow><img src={require('../../../../assets/images/reactivate.png')} /></Tooltip></Button>
                            : ''}
                            {loginUser.roles_id == 15 && row.original.logo_config && row.original.logo_config.assigned_to != null && row.original.logo_config.assigned_to == loginUser.id
                                 ? <Button onClick={() => { reAssignUser("logo",row.original.logo_config.id,null) }}><Tooltip title="UnAssign" arrow><img src={require('../../../../assets/images/reactivate.png')} /></Tooltip></Button>:''}
                        </>
                        :''}
                    </>
                 ),
            },
            {
                accessorFn: (data) => `${data}`,
                id: 'service_requested',
                header: 'Service Requested',
                size: 50,
                Cell: ({ renderedCellValue, row }) => (
                    <>
                   { row.original.video_config ? 
                    <>
                    {row.original.video_config.map((video, index) => (
                      <div key={index}>
                        {video.media_service ? (video.media_service.service_name + ' Video') : ''} {/* or video.name, or any field in your video object */}
                      </div>
                    ))}
                  </>
                    :''}
                    
                       { row.original.logo_config ? 
                        <>
                        {
                            row.original.logo_config ? "Logo Design" : ''
                        }
                        </>
                        :''}
                    </>
                 ),
            },
            {
                id: 'action',
                header: 'Action',
                size: 50,
                Cell: ({ renderedCellValue, row }) => (
                   <>
                    <div style={{display: 'flex',alignItems: 'center',cursor:"pointer"}} onClick={() => handleClickOpen(row)}>
                        <img src={require('../../../../assets/images/seeDetails.png')} style={{width:'10%'}}/> <span style={{marginLeft:"10px"}}>See Details</span>
                    </div>
                    <div style={{marginTop: '7px',display: 'flex',alignItems: 'center',cursor:"pointer"}} onClick={() => getActivityLog(row.original.company_master_id)}>
                       <img  src={require('../../../../assets/images/activityLog.png')} style={{width:'10%'}} /><span style={{marginLeft:"10px"}}> Activity Log</span>
                    </div>
                   </>
                 ),
            },
        ]
    );

    
      //csv option start here
    const csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        fileName: 'Media Services Reqested Companies',
        headers: ['Company Name','Requested Date','Assigned To','Service Requested'],
    };
    
    const csvExporter = new ExportToCsv(csvOptions);
    const handleExportData = (data) => {
        var check = checkUserRole();
        if(check === true) {
            const exportedData = [];
            data.forEach((row) => {
            let serviceRequested = '';
            if (row.original.video_config) {
                row.original.video_config.forEach((video) => {
                    if(serviceRequested == '') {
                        serviceRequested =   video.media_service.service_name ? video.media_service.service_name : '';
                    }else{
                        serviceRequested =serviceRequested + ', ' + (video.media_service.service_name ? (video.media_service.service_name + " Video") : '');
                    }
                    
                });
            }
            
            if(row.original.logo_config) {
                if(serviceRequested == '') {
                    serviceRequested = "Logo Design";
                }else{
                    serviceRequested +=  ', ' + "Logo Design";
                }
            }
            let assignToData = '';
            if (row.original.video_config) {
                row.original.video_config.forEach((video) => {
                    if(assignToData == '') {
                        assignToData =   video.assigned_to != null && video.sales_admin?  video.sales_admin.name : 'N/A'  ;
                    }else{
                        assignToData +=  ', ' + (video.assigned_to != null && video.sales_admin?  video.sales_admin.name : 'N/A');
                    }
                    
                });
            }
            if(row.original.logo_config) {
                if(assignToData == '') {
                    assignToData = row.original.logo_config.assigned_to != null &&  row.original.logo_config.sales_admin ? row.original.logo_config.sales_admin.name : 'N/A';
                }else{
                    assignToData +=  ', ' + row.original.logo_config.assigned_to != null &&  row.original.logo_config.sales_admin ? row.original.logo_config.sales_admin.name : 'N/A';
                }
            }
           
            const mainTableRow = {
              companyName: `${row.original.company.company_name}` || 'N/A',
              requestedDate: `${row.original.created_at?  Moment(row.original.created_at).tz('America/Los_Angeles').format('MM-DD-YYYY'): ''}` || 'N/A',
              assignToData: assignToData || 'N/A',
              serviceRequested: serviceRequested || 'N/A',
            };
            exportedData.push(mainTableRow);
        //  exportedData.push({});
       });
      
       const csvContent = convertToCSV(exportedData);
      // Create a Blob object from the CSV data
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
      
      // Create a download link element
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = csvOptions.fileName + '.csv';
      
      // Append the link to the document body
      document.body.appendChild(link);
      
      // Programmatically click the link to trigger the file download
      link.click();
      
      // Clean up the temporary URL and remove the link from the document
      URL.revokeObjectURL(link.href);
      link.remove();
      };
    }
    
    const convertToCSV = (data) => {
      const headers = csvOptions.headers.join(',') + '\n';
    
      const rows = data.map((row) => {
        return Object.values(row).map((value) => {
          // Handle any necessary formatting or escaping of values
          // For simplicity, we assume all values are already properly formatted
    
          // Wrap the value with double quotes if it contains a comma
          if (typeof value === 'string' && value.includes(',')) {
            return `"${value}"`;
          }
    
          return value;
        }).join(',');
      }).join('\n');
    
      return headers + rows;
    };
      //csv end here
    const handleAssign =async () => {
        setMultiAssignBtnDisable(true);
        const assignToJson = [];
      
        // For videos
        companyDetails?.original?.video_config?.forEach((video) => {
            let assignedTo = '';

            if (selectAll && selectAllValue !== '' && selectAllValue !== video.assigned_to) {
                assignedTo = selectAllValue;
            } else if (assignmentsById[`video_${video.id}`]) {
                assignedTo = assignmentsById[`video_${video.id}`];
            }

            if (assignedTo && assignedTo !== video.assigned_to) {
                assignToJson.push({
                logId: video.id,
                assignTo: assignedTo,
                type: 'video',
                });
            }
        });
      
        // For logo design
        const logoId = companyDetails?.original?.logo_config?.id;
        let logoAssignedTo = '';

        if (selectAll && selectAllValue !== '' && companyDetails.original.logo_config) {
            if (selectAllValue !== companyDetails.original.logo_config.assigned_to) {
                logoAssignedTo = selectAllValue;
            }
        } else if (assignmentsById[`logo_${logoId}`]) {
            logoAssignedTo = assignmentsById[`logo_${logoId}`];
        }

        if (logoId && logoAssignedTo && logoAssignedTo !== companyDetails.original.logo_config.assigned_to) {
            assignToJson.push({
                logId: logoId,
                assignTo: logoAssignedTo,
                type: "logo"
            });
        }
        
      
        // Validation: Ensure at least one name is entered
        if (assignToJson.length === 0) {
          window.alert("Please enter at least one name before assigning.");
          return;
        }
        const apiUrl = '/assignedSingleMediaService';
        const args = {
          assignToJson
        };

        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res.success == true) {
            swal({
                title: "Success",
                text: res.message,
                icon: "success",
                button: "Ok",
            });
            setOpenAssign(false);
            setOpen(false);
            setMultiAssignBtnDisable(false);
             {loginUser.roles_id ==15 ? getEligibleAffiliates(assignTo) :getEligibleAffiliates()}
        }else{
            swal({
                title: "Error",
                text: res.message,
                icon: "error",
                button: "Ok",
            })
            setMultiAssignBtnDisable(false);
        }
        // setOpenAssign(false);
    };

    const handleSingleAssign =async () => {
        // Validation: Ensure at least one name is entered
        setAssignBtnDisable(true);
        if (assignToValue == "") {
            setSingleAssignError(true);
          return;
        }
        const apiUrl = '/assignedSingleMediaService';
        const args = {
            logId:assignItem.id,
            assignTo : assignToValue,
            type : itemType,
        };

        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res.success == true) {
            swal({
                title: "Success",
                text: res.message,
                icon: "success",
                button: "Ok",
            });
            handleCloseAssignTo(false);
            setAssignBtnDisable(false);
            {loginUser.roles_id ==15 ? getEligibleAffiliates(assignTo) :getEligibleAffiliates()}
        }else{
            swal({
                title: "Error",
                text: res.message,
                icon: "error",
                button: "Ok",
            })
            setAssignBtnDisable(false);
        }
    };  
      
    return (
        <>
            <Grid container item lg={12} spacing={2} alignItems="center" mb={2}>
                <Grid item lg={8} md={8} sm={8} xs={8}>
                </Grid>
                {loginUser.roles_id === 15 ?
                    <Grid item lg={3} md={3} sm={3} xs={3} mr={1}>
                        <FormControl fullWidth size="small" margin="dense">
                            <InputLabel id="assigned-select-label">Assigned To:</InputLabel>
                            <Select
                                labelId="assigned-select-label"
                                id="assigned-select"
                                label="Assigned To:"
                                value={assignTo}
                                onChange={(e) => { setAssignTo(e.target.value);getEligibleAffiliates(e.target.value); }}
                                MenuProps={MenuProps}
                            >
                                <MenuItem value="Me">Me</MenuItem>
                                <MenuItem value="unAssign">Unassigned</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                :""}
            </Grid>
          
            <MaterialReactTable
                columns={columns}
                data={data}
                enableColumnFilterModes
                enableGrouping={false}
                enablePinning={false}
                enableRowSelection={false}
                onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                state={{ columnVisibility, rowSelection }} //pass our managed row selection state to the table to use
                initialState={{
                    showColumnFilters: false,
                    density: 'compact',
                }}
                onColumnVisibilityChange={(state) => { setColumnVisibility(state) }}
                positionToolbarAlertBanner="bottom"
                enableDensityToggle={false}
                muiTablePaperProps={{
                    sx: { backgroundColor: "white" },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            backgroundColor: "#2A68B3",
                            color: "white",
                            fontWeight: "bold",
                            '& .MuiIconButton-root': {
                                color: 'white',
                                '&:hover': {
                                  color: 'white',
                                  backgroundColor: 'transparent', // avoid default hover bg
                                },
                                '&:focus': {
                                  color: 'white',
                                },
                                '&:active': {
                                  color: 'white',
                                },
                              },
                              '& .MuiSvgIcon-root': {
                                color: 'white',
                              },
                        },
                    }}
                
                //top csv option
                renderTopToolbarCustomActions={({ table }) => (
                    <Box sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }} >
                        <Button
                            disabled={table.getPrePaginationRowModel().rows.length === 0}
                            onClick={() =>
                                handleExportData(table.getPrePaginationRowModel().rows)
                            }
                            variant="outlined"
                            color="primary"
                            sx={{borderRadius:"10px",fontWeight:"bold",fontSize:"large",minWidth:isMobile?100:130,border:"1px solid #2A68B3"}}
                        >
                        CSV
                        </Button>

                    </Box>
                    )
                }
            />

            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={open}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
                PaperProps={{
                    sx: {
                      top: 0,
                      borderRadius:"20px",
                      boxShadow:"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                    },

                  }}
            >
                <Card width={"100%"} sx={{overflow:isMobile?"scroll":"auto"}}>
                      
                    <CardContent>
                    <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"} p={1}>
                            <Grid item lg={6} md={6} sm={9} xs={9}>
                                <Typography variant='h5' fontWeight={"bold"}>Services Requested</Typography>
                            </Grid>
                            <Grid item lg={6} md={6} sm={3} xs={3} textAlign={"right"}>
                                <IconButton edge="end" onClick={handleClose}>
                                    <img src={require("../../../../assets/images/close.png")}
                                        style={{ height: "25px" }}
                                        alt="close" />
                                </IconButton>
                            </Grid>

                        </Grid>
                        {
                            companyDetails.original ?
                            <>
                             <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} alignItems="stretch">
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Card variant='outlined' sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column", border: "1px solid #AD9E9E", borderRadius: "9px" }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                                <Typography variant='body2' fontWeight={"bold"}>company Name</Typography>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={6} xs={6} textAlign={"right"}>
                                                <Typography variant='body2'>{companyDetails ? companyDetails.original.company ? companyDetails.original.company.company_name : '' : ''}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={3} md={3} sm={3} xs={3}>
                                                <Typography variant='body2' fontWeight={"bold"}>Email</Typography>
                                            </Grid>
                                            <Grid item lg={9} md={9} sm={9} xs={9} textAlign={"right"}>
                                                <Typography variant='body2'>{companyDetails ? companyDetails.original.reference_affiliates ? companyDetails.original.reference_affiliates.communication_email : '' : ''}</Typography>
                                            </Grid>
                                        </Grid> 
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                                <Typography variant='body2' fontWeight={"bold"}>Phone no</Typography>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={6} xs={6} textAlign={"right"}>
                                                <Typography variant='body2'>{companyDetails ? companyDetails.original.reference_affiliates ? companyDetails.original.reference_affiliates.phone_no : '' : ''}</Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                                <Typography variant='body2' fontWeight={"bold"}>Enrollments</Typography>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={6} xs={6} textAlign={"right"}>
                                                <Typography variant='body2'>{companyDetails ? companyDetails.original.monthly_active_count ? companyDetails.original.monthly_active_count.count : ''  : ''}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Card variant='outlined' sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column", border: "1px solid #AD9E9E", borderRadius: "9px" }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Grid item lg={4} md={4} sm={4} xs={4}>
                                                <Typography variant='body2' fontWeight={"bold"}>Services</Typography>
                                            </Grid>
                                           
                                            {
                                                companyDetails ? companyDetails.original.video_config ? 
                                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                                     <Grid container direction="column" alignItems="flex-end">
                                                    {companyDetails.original.video_config.map((video, index) => (
                                                        <Typography variant='body2' textAlign={"end"}>{video.media_service ?(video.media_service.service_name + " Video")  : ''}</Typography>
                                                    ))}
                                                    </Grid>
                                                  </Grid>
                                                :'' :''
                                            }
                                         </Grid>
                                         {
                                            companyDetails ? companyDetails.original.logo_config ? 
                                            <>
                                               
                                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="end">
                                                    <Typography variant='body2'>Logo Design</Typography>
                                                </Grid>
                                                
                                            </>
                                            :'' :''
                                        }
                                        
                                    </Card>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} mt={1} alignItems="stretch">
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Card variant='outlined' sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column", border: "1px solid #AD9E9E", borderRadius: "9px" }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography fontWeight={"bold"} varient="body2">What's the name of your brand or business?</Typography>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography varient="body2">
                                                {companyDetails ? companyDetails.original.brand_name : ''}
                                            </Typography>
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Card variant='outlined' sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column", border: "1px solid #AD9E9E", borderRadius: "9px" }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography fontWeight={"bold"} varient="body2">Who is your ideal client?</Typography>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography varient="body2">
                                                {companyDetails ? companyDetails.original.ideal_client : ''}
                                            </Typography>
                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} mt={1} alignItems="stretch">
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Card variant='outlined' sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column", border: "1px solid #AD9E9E", borderRadius: "9px" }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography fontWeight={"bold"} varient="body2">What do you help people do?</Typography>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography varient="body2">
                                            {companyDetails ? companyDetails.original.what_you_do : ''}
                                            </Typography>
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Card variant='outlined' sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column", border: "1px solid #AD9E9E", borderRadius: "9px" }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            <Typography fontWeight={"bold"} varient="body2">Drop your website, social links, or anything else you want us to see.</Typography>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                                            {companyDetails?.original?.business_url &&
                                            (() => {
                                                let urls;

                                                try {
                                                let raw = companyDetails.original.business_url;

                                                // Keep parsing until it becomes an object
                                                while (typeof raw === 'string') {
                                                    raw = JSON.parse(raw);
                                                }

                                                urls = raw;
                                                } catch (e) {
                                                console.error('Invalid JSON in business_url', e);
                                                return null;
                                                }

                                                return Object.entries(urls).map(([key, value]) => {
                                                if (Array.isArray(value)) {
                                                    return value.map((url, i) => (
                                                    <Typography key={`${key}-${i}`} variant="body2" sx={{ wordBreak: "break-all" }}>
                                                        <strong>{key}:</strong> <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
                                                    </Typography>
                                                    ));
                                                }

                                                return (
                                                    <Typography key={key} variant="body2" sx={{ wordBreak: "break-all" }}>
                                                    <strong>{key}:</strong> <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>
                                                    </Typography>
                                                );
                                                });
                                            })()
                                            }
                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>
                            {/* <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                                    <Typography fontWeight={"bold"} variant='body2'>Opted for:<span style={{ fontWeight: "normal" }}>{companyDetails ? companyDetails.original.template_no ? companyDetails.original.template_no :companyDetails.original.template_description : '' }</span></Typography>
                            </Grid>   */}
                                {/* <Grid item lg={2} md={2} sm={2} xs={2}>
                                    <Typography variant='body2'>Or</Typography>
                                </Grid>
                                <Grid item lg={5} md={5} sm={5} xs={5}>
                                    <Typography fontWeight={"bold"} variant='body2'>Opted for:<span style={{ fontWeight: "normal" }}>I'll write my Own (with Coaching)</span></Typography>
                                </Grid> */}
                          
                            {/* <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                                <Grid item lg={5} md={5} sm={12} xs={12} display={"flex"} alignItem={"center"}>
                                    <Typography variant='body2' fontWeight={"bold"} alignItem={"center"}>Booked a video strategy call:</Typography>
                                </Grid>
                                <Grid item lg={7} md={7} sm={12} xs={12}>
                                    <TextField
                                    label="Call link"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    value={companyDetails ?companyDetails.original.meeting_link ? companyDetails.original.meeting_link : '' : ''}
                                    size='small'/>
                                </Grid>
                            </Grid>*/}
                            <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={isMobile?"center":"right"} mt={2}>
                                <Button variant='outlined' onClick={handleClose} color='primary'sx={{ minWidth: 300, borderRadius: "10px",fontWeight:"bold" }}>Cancel</Button> &nbsp;&nbsp;
                                <Button variant='contained' color='primary' sx={{ minWidth: 300, borderRadius: "10px",fontWeight:"bold",marginTop:isMobile?"16px !important":0 }} onClick={() => setOpenAssign(true)}>Assign To</Button>
                            </Grid>
                            </>
                            :''
                        }
                       
                    </CardContent>
                </Card>
            </Dialog>

            <Dialog
                open={openAssign}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        setOpenAssign(false);
                    }
                }}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                PaperProps={{
                    sx: {
                        borderRadius: "12px",
                        padding: "20px"
                    }
                }}
            >
                <DialogTitle className="dialog-title" >
                    <Typography variant="h6" fontWeight="bold"> Assign To </Typography>
                    <IconButton onClick={(e)=>{setOpenAssign(false)}}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                {companyDetails.original ?
                <>
                {companyDetails ? companyDetails.original.video_config.length > 0 ? 
                <>
                 {
                // Check if none are assigned
                !companyDetails.original.video_config.some(video => video.assigned_to) && (
                    <Grid item xs={12} mb={2}>
                        <FormControlLabel
                        control={
                            <Checkbox
                            checked={selectAll}
                            onChange={(e) => handleSelectAllChange(e.target.checked)}
                            />
                        }
                        label="Select All"
                        />
                    </Grid>
                    )
                }
                
                    {companyDetails.original.video_config.map((video, index) => (
                    <Grid item xs={12} md={6} mt={1}>
                        <Grid container alignItems="center" spacing={2}>
                            {/* Title */}
                            <Grid item xs={6}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={video.media_service ? (video.media_service.service_name + " Video")  : ''}
                            />
                            </Grid>

                            {/* TextField */}
                            
                                {selectAll ? (
                                    index === 0 && (
                                        <Grid item xs={6}>
                                            {video.assigned_to ? (
                                                    <>
                                                        <Grid item xs={10}>
                                                            <TextField
                                                                fullWidth
                                                                margin="dense"
                                                                size="small"
                                                                variant="outlined"
                                                                label="Assigned to"
                                                                value={
                                                                    adminList.find(admin => String(admin.id) === String(video.assigned_to))?.name || ''
                                                                    }
                                                                InputProps={{readOnly: true,}}
                                                            />
                                                        </Grid>
                                                    </>
                                            ):(
                                            <FormControl fullWidth margin='dense' size="small">
                                                <InputLabel id="demo-multiple-name-label">Assigned to</InputLabel>
                                                <Select
                                                id="assignedto"
                                                name="assignedto"
                                                input={<OutlinedInput label="Assigned To" />}
                                                value={selectAllValue !== '' ? selectAllValue : (video.assigned_to ?? '')}
                                                onChange={(e) => {
                                                    setSelectAllValue(e.target.value);
                                                    setMultiAssignBtnDisable(false);
                                                }}
                                                MenuProps={MenuProps}
                                                size='small'
                                                >
                                                {adminList.map((array) => (
                                                    <MenuItem
                                                    key={array.id} // Ensure each MenuItem has a unique key
                                                    value={array.id}
                                                    >
                                                    {array.name}
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                            )}
                                        </Grid>
                                    )
                                ) : (
                                    <>
                                        <Grid item xs={6}>
                                            <Grid container alignItems="center" spacing={1}>
                                                {video.assigned_to ? (
                                                <>
                                                    <Grid item xs={10}>
                                                    <TextField
                                                        fullWidth
                                                        margin="dense"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Assigned to"
                                                        value={
                                                            adminList.find(admin => String(admin.id) === String(video.assigned_to))?.name || ''
                                                            }
                                                        InputProps={{readOnly: true,}}
                                                    />
                                                    </Grid>
                                                    {loginUser.roles_id < 3 &&
                                                        <Grid item xs={2}>
                                                            <Button onClick={() => { reAssignUser("video",video.id, video.assigned_to) }} ><Tooltip title="ReAssign" arrow><img src={require('../../../../assets/images/reactivate.png')} /></Tooltip></Button>
                                                        </Grid>
                                                    }
                                                </>
                                                ) : (
                                                <FormControl fullWidth margin="dense" size="small">
                                                    <InputLabel id="demo-multiple-name-label">Assigned to</InputLabel>
                                                    <Select
                                                    id="assignedto"
                                                    name="assignedto"
                                                    input={<OutlinedInput label="Assigned To" />}
                                                    value={assignmentsById[`video_${video.id}`] ?? ''}
                                                    onChange={(e) => {
                                                        setAssignmentsById(prev => ({
                                                        ...prev,
                                                        [`video_${video.id}`]: e.target.value
                                                        }));
                                                        setMultiAssignBtnDisable(false);
                                                    }}
                                                    MenuProps={MenuProps}
                                                    size="small"
                                                    >
                                                    {adminList.map((array) => (
                                                        <MenuItem key={array.id} value={array.id}>
                                                        {array.name}
                                                        </MenuItem>
                                                    ))}
                                                    </Select>
                                                </FormControl>
                                                )}
                                            </Grid>
                                               
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    ))}
                </>
                :'' :''
                }
                {
                    companyDetails ? companyDetails.original.logo_config ? 
                    <>
                        <Grid item xs={12} md={6} mt={1}>
                            <Grid container alignItems="center" spacing={2}>
                                {/* Title */}
                                <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value="Logo Design"
                                />
                                </Grid>

                                {/* TextField */}
                                
                                {selectAll ? 
                                (''):(
                                    <Grid item xs={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            {companyDetails.original.logo_config.assigned_to ? (
                                                <>
                                                <Grid item xs={10}>
                                                    <TextField
                                                        fullWidth
                                                        margin="dense"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Assigned to"
                                                        value={
                                                            adminList.find(admin => String(admin.id) === String(companyDetails.original.logo_config.assigned_to))?.name || ''
                                                            }
                                                        InputProps={{readOnly: true,}}
                                                    />
                                                    </Grid>
                                                    {loginUser.roles_id < 3 &&
                                                        <Grid item xs={2}>
                                                            <Button onClick={() => { reAssignUser("logo",companyDetails.original.logo_config.id, companyDetails.original.logo_config.assigned_to) }} ><Tooltip title="ReAssign" arrow><img src={require('../../../../assets/images/reactivate.png')} /></Tooltip></Button>
                                                        </Grid>
                                                    }
                                                </>
                                                ) : (
                                                <FormControl fullWidth margin='dense' size="small">
                                                <InputLabel id="demo-multiple-name-label">Assigned to</InputLabel>
                                                <Select
                                                id="assignedto"
                                                name="assignedto"
                                                input={<OutlinedInput label="Assigned To" />}
                                                value={
                                                assignmentsById[`logo_${companyDetails.original.logo_config.id}`] ??
                                                companyDetails.original.logo_config.assigned_to ?? ''
                                                }
                                                onChange={(e) => {
                                                const logoId = companyDetails.original.logo_config.id;
                                                setAssignmentsById(prev => ({
                                                    ...prev,
                                                    [`logo_${logoId}`]: e.target.value
                                                }));
                                                setMultiAssignBtnDisable(false);
                                                }}
                                                MenuProps={MenuProps}
                                                size='small'
                                                >
                                                {adminList.map((array) => (
                                                    <MenuItem
                                                    key={array.id} // Ensure each MenuItem has a unique key
                                                    value={array.id}
                                                    >
                                                    {array.name}
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                                    </FormControl>
                                                )
                                            }
                                        </Grid>
                                    </Grid>
                                )}
                                </Grid>
                        </Grid>
                    </>
                    :'' :''
                }
                </>
                :''}
                </DialogContent>
                <DialogActions>
                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }} spacing={2} mt={1}>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained"  onClick={() =>setOpenAssign(false)} className="cancel-button" disabled={multiAssignBtnDisable}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained"  className="save-button" onClick={handleAssign} disabled={multiAssignBtnDisable}>
                                Assign
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <Dialog
                open={singleOpenAssignTo}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        setSingleOpenAssignTo(false);
                        setAssignBtnDisable(false);
                    }
                }}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                PaperProps={{
                    sx: {
                        borderRadius: "12px",
                        padding: "20px"
                    }
                }}
            >
                <DialogTitle className="dialog-title" >
                    <Typography variant="h6" fontWeight="bold"> Assign To </Typography>
                    <IconButton onClick={handleCloseAssignTo}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                {assignItem && itemType?
                <>
                    <Grid item xs={12} md={6} mt={1}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item xs={6}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={ itemType === 'video'
                                        ? (assignItem.media_service?.service_name || '') + ' Video'
                                        : 'Logo Design'}
                            />
                            </Grid>
                            <Grid item xs={6}>
                                    <FormControl fullWidth margin='dense' size="small">
                                        <InputLabel id="demo-multiple-name-label">Assigned to</InputLabel>
                                        <Select
                                        id="assignedto"
                                        name="assignedto"
                                        input={<OutlinedInput label="Assigned To" />}
                                        // value={assignToValue}
                                        // onChange={handleSelectChange}
                                        onChange={(e) => {
                                            setAssignToValue(e.target.value);
                                            setAssignBtnDisable(false);
                                            setSingleAssignError(false);
                                        }}
                                        MenuProps={MenuProps}
                                        size='small'
                                        >
                                        {adminList.map((array) => (
                                            <MenuItem
                                            key={array.id} // Ensure each MenuItem has a unique key
                                            value={array.id}
                                            >
                                            {array.name}
                                            </MenuItem>
                                        ))}
                                        </Select>
                                    </FormControl>
                                    <div style={{ color: 'red' }}>{singleAssignError ? "Please Enter Name" : ''}</div>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
                :''
                }
                </DialogContent>
                <DialogActions>
                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "center", width: "100%" }} spacing={2} mt={1}>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained"  onClick={handleCloseAssignTo} className="cancel-button">
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Button variant="contained"  className="save-button" onClick={handleSingleAssign} disabled={assignBtnDisable}>
                                Assign
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openReassign}
                onClose={handle}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={fullWidth}
                maxWidth={maxWidth}
            >
                <DialogTitle id="alert-dialog-title" className="back">
                <Typography variant='h5'>Re-Assign User</Typography>
                </DialogTitle>
                <DialogContent>
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12}>
                        <TextField
                        fullWidth
                        label="Note (Reason for reassignment)"
                        variant="outlined"
                        size="small"
                        multiline
                        rows={3}
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        />
                    </Grid>
                    {assigedUser !== null && (
                        <Grid item xs={12}>
                            <FormControl fullWidth size='small'>
                            <InputLabel id="demo-multiple-name-label">Select User</InputLabel>
                            <Select
                                labelId="demo-multiple-name-label"
                                name='assigedUser'
                                id='assigedUser'
                                label="Select User"
                                value={assigedUser}
                                onChange={(e) => { setAssigedUser(e.target.value) }}
                                MenuProps={MenuProps}
                            >
                                {adminList.map((array) => (
                                    <MenuItem
                                    key={array.id} // Ensure each MenuItem has a unique key
                                    value={array.id}
                                    >
                                    {array.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                        </Grid>
                    )}
                </Grid>
                </DialogContent>
                <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant="contained" color="primary" sx={{ minWidth: 200 }} onClick={handle}>Close</Button>
                <Button variant="contained" color="success" sx={{ minWidth: 200 }} onClick={ChangeAssignedUser}>Save</Button>
                </DialogActions>
            </Dialog>
            
        </>
    );
}

export default MediaServiceReqestedAffiliateList;